import { getRequest, postRequest } from "./request";

const Music: any = {};

Music.getMusic = async () => {
  return await getRequest({ url: `/music` });
};

export default Music;
